
import React from "react";
import theme from "../../../styles/theme";

const Card = ({ title, children, width = "auto", height = "auto" }) => {
  return (
    <div
      style={{
        border: `1px solid ${theme.colors.borders.default}`,
        borderRadius: theme.borders.radius.md,
        padding: theme.spacing.lg,
        backgroundColor: theme.colors.background.surface,
        boxShadow: theme.shadows.sm,
        transition: "all 0.2s",
        cursor: "default",

        // 🔹 Taille contrôlable depuis l'extérieur
        width,
        height,

        // 🔹 Mise en page interne soignée
        display: "flex",
        flexDirection: "column",
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.md;
        e.currentTarget.style.transform = "translateY(-2px)";
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.boxShadow = theme.shadows.sm;
        e.currentTarget.style.transform = "translateY(0)";
      }}
    >
      {title && (
        <h3
          style={{
            fontSize: theme.fontSizes.lg,
            fontWeight: theme.fontWeights.medium,
            color: theme.colors.text.default,
            marginBottom: theme.spacing.md,
          }}
        >
          {title}
        </h3>
      )}

      {children}
    </div>
  );
};

export default Card;
